import React from 'react'
import QuestionTpl from '../templates/QuestionTpl'
import { NumberInput } from './NumberInput'

export default class SalaryQn extends React.Component {

    static id = 'salary';
    static defaultValue = '60000';

    render() {
        const { id, value, onChange } = this.props;
        
        return (
            <QuestionTpl
                {...this.props}
                title="Salary"
                description="Your annual salary"
                fineprint="This is how much you earn before tax."
                component={NumberInput}
                componentProps={{
                    value,
                    onChange: (e) => onChange(id, e.target.value),
                    min: 18000,
                    max: 1000000,
                    step: 1000
                }}
            />
        );
    }
}
